import type { BeforeRequestHook } from 'ky';
import { HTTP_HEADERS } from '../../../../auth/const';
import { isServer } from '../../utils';
import type { HookGetterArgs } from '../types';

export const getDeltaMatrixHeaders = ({ options: { meta } }: HookGetterArgs): BeforeRequestHook => {
  const deltaMatrixHeadersHook: BeforeRequestHook = (request) => {
    if (!isServer() && (meta?.apiDomain ?? '__unifyBaseUrl' in window)) {
      // If interfaceId exists in meta use it, ideally this should be always available. We shouldn't rely on window.__unifyAppId
      const appId =
        meta?.interfaceId ?? ('__unifyAppId' in window ? (window.__unifyAppId as string) : '');

      request.headers.set(HTTP_HEADERS.AppId, appId);
      if ('__unifyTenantDomain' in window && typeof window.__unifyTenantDomain !== 'undefined') {
        request.headers.set(HTTP_HEADERS.TenantDomain, window.__unifyTenantDomain as string);
      }

      if ('__unifyTenantURI' in window && typeof window.__unifyTenantURI !== 'undefined') {
        request.headers.set(HTTP_HEADERS.TenantURI, window.__unifyTenantURI as string);
      }
    }
  };
  return deltaMatrixHeadersHook;
};
